function Products() {
  return (
    <div className="p-8">
      <h2 className="text-3xl font-bold mb-8 text-center">Our Products</h2>

      {/* Handheld Card Reader Section */}
      <section className="mb-16 p-6 border border-gray-300 rounded-lg bg-white shadow-md flex flex-col md:flex-row items-center space-y-6 md:space-y-0 md:space-x-8">
        <img
          src="/handheld-reader.png"
          alt="Handheld Card Reader"
          className="w-full md:w-1/3 object-contain rounded"
        />
        <div className="text-blue-800 font-semibold space-y-4 text-lg">
          <h3 className="text-2xl font-bold mb-2">Handheld Card Reader</h3>
          <div className="p-4 border border-blue-300 bg-blue-50 rounded">
            <p>
              - No upfront costs<br />
              - Low percentage of sales only<br />
              - Same-day payment processing<br />
              - Zero maintenance fees<br />
              - Always connected — no downtime
            </p>
            <p className="mt-4">
              Our system is trusted by 85% of hotels in Las Vegas and 92% of sports venues in America.
            </p>
          </div>
        </div>
      </section>

      {/* POS System Section */}
      <section className="p-6 border border-gray-300 rounded-lg bg-white shadow-md flex flex-col md:flex-row items-center space-y-6 md:space-y-0 md:space-x-8">
        <img
          src="/pos-terminal.jpg"
          alt="POS System"
          className="w-full md:w-1/3 object-contain rounded"
        />
        <div className="text-blue-800 font-semibold space-y-4 text-lg">
          <h3 className="text-2xl font-bold mb-2">Complete POS System</h3>
          <div className="p-4 border border-blue-300 bg-blue-50 rounded">
            <p>
              - No upfront costs<br />
              - One affordable flat rate<br />
              - No transaction fees, no separate statements<br />
              - Lifetime hardware warranty and 24/7 UK-based support
            </p>
            <p className="mt-4">
              Fully customisable for your business — seamless communication front and back of house.
            </p>
            <p>
              Real-time insights, menu/pricing updates, staff tracking, customer insights, and marketing tools all in one.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Products;
